import tw, { styled } from "twin.macro";

export const StyledConfirmCodeController = styled.div`
  ${tw`flex flex-col gap-m`}
`;
